import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=0312b9c6&"
import script from "./OrderStatus.vue?vue&type=script&lang=js&"
export * from "./OrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0312b9c6')) {
      api.createRecord('0312b9c6', component.options)
    } else {
      api.reload('0312b9c6', component.options)
    }
    module.hot.accept("./OrderStatus.vue?vue&type=template&id=0312b9c6&", function () {
      api.rerender('0312b9c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/OrderStatus.vue"
export default component.exports